import api from './api';

/**
 * Simple hash function to obfuscate password before sending
 * Note: This is not encryption, just basic obfuscation.
 * Real security comes from HTTPS. The server still needs to verify the password.
 */
const hashPassword = (password) => {
  // Simple base64 encoding for obfuscation (not real security)
  // In production, ensure HTTPS is used
  return btoa(encodeURIComponent(password));
};

/**
 * Login admin user
 * @param {string} email - Admin email
 * @param {string} password - Admin password (will be hashed before sending)
 */
export const login = async (email, password) => {
  // Hash password before sending (basic obfuscation)
  // Note: Server should still accept plain password and hash it server-side
  // This is just to avoid sending plain password in network requests
  const hashedPassword = hashPassword(password);
  
  const response = await api.post('/login', { 
    email, 
    password: hashedPassword 
  });
  
  // Don't store password anywhere - only token and user data
  return response.data;
};

/**
 * Logout admin user
 */
export const logout = async () => {
  try {
    await api.post('/logout');
  } catch (error) {
    // Continue with logout even if API call fails
    console.error('Logout error:', error);
  } finally {
    // Clear local storage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refresh_token');
  }
};

/**
 * Get current authenticated user
 */
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      return null;
    }
  }
  return null;
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

/**
 * Check if user is admin
 */
export const isAdmin = () => {
  const user = getCurrentUser();
  return user && user.role === 'admin';
};

/**
 * Get auth token
 */
export const getToken = () => {
  return localStorage.getItem('token');
};
